<div
    class="w-full flex flex-col gap-4 p-4 sm:max-w-200 mx-auto"
    [formGroup]="form"
>
    <p-card>
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar Holding</h1>

            <app-input
                id="nome"
                label="Nome"
                formControlName="NOME"
            ></app-input>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
